@if (product$ | async; as product) {
  <div class="container">
    <h2>{{ 'productDetails.reviews' | cxTranslate }} ({{ product.numberOfReviews }})</h2>
    @if (!isWritingReview) {
      <div class="header">
        <h3 class="h5">{{ 'productReview.overallRating' | cxTranslate }}</h3>
        <button #writeReviewButton class="btn btn-primary" (click)="initiateWriteReview()">
          {{ 'productReview.writeReview' | cxTranslate }}
        </button>
        @if (product.averageRating) {
          <cx-star-rating class="rating" [rating]="product.averageRating"></cx-star-rating>
        }
        @if (!product.averageRating) {
          <div class="rating">
            {{ 'productDetails.noReviews' | cxTranslate }}
          </div>
        }
      </div>
      @if (!isWritingReview) {
        @if (reviews$ | async; as reviews) {
          @for (review of reviews | slice: 0 : maxListItems; track review) {
            <div class="review" tabindex="0">
              <div class="title">{{ review.headline }}</div>
              <cx-star-rating [rating]="review.rating ?? 0"></cx-star-rating>
              <div class="name">
                {{ review.alias ? review.alias : review.principal?.name }}
              </div>
              <div class="date">{{ review.date | cxDate: 'MM/dd/yyyy' }}</div>
              <div class="text">{{ review.comment }}</div>
            </div>
          }
          @if (reviews.length > initialMaxListItems) {
            <div>
              @if (maxListItems === initialMaxListItems) {
                <button class="btn btn-primary" (click)="maxListItems = reviews.length">
                  {{ 'productReview.more' | cxTranslate }}
                </button>
              }
              @if (maxListItems !== initialMaxListItems) {
                <button class="btn btn-primary" (click)="maxListItems = initialMaxListItems">
                  {{ 'productReview.less' | cxTranslate }}
                </button>
              }
            </div>
          }
        }
      } @else {
        <!-- TODO: (CXSPA-5953) Remove feature flags next major -->
        <p *cxFeature="'a11yRequiredAsterisks'" class="form-legend">
          {{ 'formLegend.required' | cxTranslate }}
        </p>
        <form (ngSubmit)="submitReview(product)" [formGroup]="reviewForm">
          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'productReview.reviewTitle' | cxTranslate }}
                <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
              </span>
              <input required="true" #titleInput type="text" class="form-control" formControlName="title" />
              <cx-form-errors [control]="reviewForm.get('title')"></cx-form-errors>
            </label>
          </div>
          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'productReview.writeYourComments' | cxTranslate }}
                <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
              </span>
              <textarea required="true" class="form-control" rows="3" formControlName="comment"></textarea>
              <cx-form-errors [control]="reviewForm.get('comment')"></cx-form-errors>
            </label>
          </div>
          <div class="form-group">
            <label>
              <span class="label-content"
                >{{ 'productReview.rating' | cxTranslate }}
                <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
              </span>
              <input required="true" type="number" formControlName="rating" class="rating-input" />
              <cx-star-rating
                tabindex="0"
                [attr.aria-label]="'productReview.ratingRequired' | cxTranslate"
                (change)="setRating($event)"
                [disabled]="false"
              ></cx-star-rating>
              <cx-form-errors [control]="reviewForm.get('rating')"></cx-form-errors>
            </label>
          </div>
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'productReview.reviewerName' | cxTranslate }} </span>
              <input type="text" class="form-control" formControlName="reviewerName" />
            </label>
          </div>
          <div class="form-group row form-actions">
            <div class="col-12 col-md-4 m-t-20">
              <button type="button" class="btn btn-block btn-outline-primary w-100" (click)="cancelWriteReview()">
                {{ 'common.cancel' | cxTranslate }}
              </button>
            </div>
            <div class="col-12 col-md-4 m-t-20">
              <button type="submit" class="btn btn-block btn-primary w-100">
                {{ 'common.submit' | cxTranslate }}
              </button>
            </div>
          </div>
        </form>
      }
    } @else {
      <!-- TODO: (CXSPA-5953) Remove feature flags next major -->
      <p *cxFeature="'a11yRequiredAsterisks'" class="form-legend">
        {{ 'formLegend.required' | cxTranslate }}
      </p>
      <form (ngSubmit)="submitReview(product)" [formGroup]="reviewForm">
        <div class="form-group">
          <label>
            <span class="label-content"
              >{{ 'productReview.reviewTitle' | cxTranslate }}
              <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
            </span>
            <input required="true" #titleInput type="text" class="form-control" formControlName="title" />
            <cx-form-errors [control]="reviewForm.get('title')"></cx-form-errors>
          </label>
        </div>
        <div class="form-group">
          <label>
            <span class="label-content"
              >{{ 'productReview.writeYourComments' | cxTranslate }}
              <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
            </span>
            <textarea required="true" class="form-control" rows="3" formControlName="comment"></textarea>
            <cx-form-errors [control]="reviewForm.get('comment')"></cx-form-errors>
          </label>
        </div>
        <div class="form-group">
          <label>
            <span class="label-content"
              >{{ 'productReview.rating' | cxTranslate }}
              <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
            </span>
            <input required="true" type="number" formControlName="rating" class="rating-input" />
            <cx-star-rating
              tabindex="0"
              [attr.aria-label]="'productReview.ratingRequired' | cxTranslate"
              (change)="setRating($event)"
              [disabled]="false"
            ></cx-star-rating>
            <cx-form-errors [control]="reviewForm.get('rating')"></cx-form-errors>
          </label>
        </div>
        <div class="form-group">
          <label>
            <span class="label-content">{{ 'productReview.reviewerName' | cxTranslate }} </span>
            <input type="text" class="form-control" formControlName="reviewerName" />
          </label>
        </div>
        <div class="form-group row form-actions">
          <div class="col-12 col-md-4 m-t-20">
            <button type="button" class="btn btn-block btn-outline-primary w-100" (click)="cancelWriteReview()">
              {{ 'common.cancel' | cxTranslate }}
            </button>
          </div>
          <div class="col-12 col-md-4 m-t-20">
            <button type="submit" class="btn btn-block btn-primary w-100">
              {{ 'common.submit' | cxTranslate }}
            </button>
          </div>
        </div>
      </form>
    }
  </div>
}

<ng-template #requiredAsterisk>
  <abbr *cxFeature="'a11yRequiredAsterisks'" class="text-decoration-none" title="{{ 'common.required' | cxTranslate }}">*</abbr>
</ng-template>
